module.exports = __webpack_public_path__ + "img/temp.ab9c7b71.png";